var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeadReportsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3484 19.232C16.8291 19.232 18.034 18.0271 18.034 16.5457V3.45605C18.034 1.97544 16.8291 0.770508 15.3484 0.770508H4.65283C3.17221 0.770508 1.96729 1.97544 1.96729 3.45605V16.5457C1.96729 18.0271 3.17221 19.232 4.65283 19.232H15.3484ZM3.50575 16.5457V3.45605C3.50575 2.82354 4.02032 2.30897 4.65283 2.30897H15.3484C15.981 2.30897 16.4955 2.82354 16.4955 3.45605V16.5457C16.4955 17.179 15.981 17.6936 15.3484 17.6936H4.65283C4.02032 17.6936 3.50575 17.179 3.50575 16.5457Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9631 14.4053H6.56617C6.14099 14.4053 5.79694 14.7493 5.79694 15.1745C5.79694 15.5997 6.14099 15.9437 6.56617 15.9437H9.9631C10.3883 15.9437 10.7323 15.5997 10.7323 15.1745C10.7323 14.7493 10.3883 14.4053 9.9631 14.4053Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4352 10.7295H6.56617C6.14099 10.7295 5.79694 11.0735 5.79694 11.4987C5.79694 11.9239 6.14099 12.268 6.56617 12.268H13.4352C13.8603 12.268 14.2044 11.9239 14.2044 11.4987C14.2044 11.0735 13.8603 10.7295 13.4352 10.7295Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.67287 8.71963L8.60796 6.7004L11.0028 8.22684C11.3175 8.42817 11.7367 8.37183 11.9884 8.09163L14.4561 5.34148C14.74 5.02522 14.7137 4.53919 14.3975 4.25524C14.082 3.97129 13.5959 3.99833 13.3112 4.31383L11.2792 6.57871L8.90243 5.06353C8.59444 4.86897 8.18879 4.91555 7.93414 5.17997L5.56259 7.65443C5.26812 7.96167 5.27864 8.44845 5.58513 8.74217C5.89081 9.03556 6.37747 9.02679 6.67287 8.71963Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadReportsIcon);
export default __webpack_public_path__ + "static/media/lead-reports-icon.e91090d1638c3ab5a8a9b021150eb24f.svg";
export { ForwardRef as ReactComponent };